import React from 'react';

const MonthlyTable = ({firstType, labels, data}) => {
    return (
        <table id="displacement-monthly-data" className={`table report-table ${firstType === "MONTHLY_VIEW" ? "" : "hidden!"}`} sheet-name="Ocorrências por naturezas">
            <thead className="thead-background print:table-row-group!">
            <tr className="bg-[#f6f6f6] text-left">
                { labels.length > 0 &&
                    labels.map((item, colIndex) => {
                        return <th className={colIndex === 0 ? "" : "text-center" }>{item}</th>
                    })
                }
            </tr>
            </thead>
            <tbody className="bg-white">

            {data.monthlyData.map((element, rowIndex) => {
                return (
                    <tr key={`row-${rowIndex}`} className="table-break-word">
                        {labels.length > 0 &&
                            labels.map((item, colIndex) => {
                                return (
                                    <td className={colIndex === 0 ? "" : "text-center" } key={`col-${rowIndex}-${colIndex}`}>
                                        {element[item]}
                                    </td>
                                );
                            })
                        }
                    </tr>
                )
            })}
            </tbody>
        </table>
    );
};

export default MonthlyTable;
